import { useNavigate } from "react-router-dom";
import React from "react";
import { useState } from "react";
import { Button } from "@mui/material";
import SearchBar from "../../components/SearchBar";
import AddIcon from '@mui/icons-material/Add';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { toast } from "react-toastify";
import { useExportUsersMutation } from "../../service/features/api";


interface UserTopbarProps {
  searchTerm: string;
  setDebouncedSearchTerm: React.Dispatch<React.SetStateAction<string>>;
}

const UserTopbar = ({ searchTerm, setDebouncedSearchTerm }: UserTopbarProps) => {

  const navigate = useNavigate();
  const [exportUsers, { isLoading: isExporting }] = useExportUsersMutation();

  const handleExport = async () => {
    try {
      const res = await exportUsers({}).unwrap();
      if (res?.data?.fileUrl) {
        window.open(res.data.fileUrl, "_blank");
        toast.success(res?.message || "USER_CSV_GENERATED_SUCCESSFULLY");
      }
    } catch (error: any) {
      toast.error(error?.data?.message || "Failed to export users");
    }
  };


  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <SearchBar
            searchTerm={searchTerm}
            setDebouncedSearchTerm={setDebouncedSearchTerm}
            placeholder="بحث... / Search..."
          />

        </div>
        <div className="right_s">
          <Button
            className="btn btn_primary"
            onClick={handleExport}
            disabled={isExporting}
          >
            {isExporting ? "Exporting..." : <><FileDownloadOutlinedIcon /> تصدير CSV / Export CSV</>}
          </Button>
          {/* <Button className="btn btn_primary" onClick={() => navigate('/manage-users/add')}><AddIcon /> Add Customer</Button> */}
        </div>
      </div>
    </>
  );
};

export default UserTopbar;
